<template>
  <v-container style="padding-top:0px">

    <div id="printDiv">
      <!-- <v-row>
        <v-col cols="12" sm="12">
          <div id="curve_chart" style="width: 900px; height: 500px"></div>
        </v-col>
      </v-row>-->

      <!-- <v-col class="print_button" style="padding-bottom:0" cols="12">
        <v-btn @click="print" small class="right" color="primary">
          <v-icon left>mdi-printer</v-icon>Print
        </v-btn>

        <v-btn @click="savePDF" small class="ma-2 right" color="primary">
          <v-icon left>mdi-download</v-icon>PDF
        </v-btn>
      </v-col>-->
      <!-- <v-row class="ml-1 mr-1">
        <v-btn text @click="back">{{ $t('cart.go_back') }}</v-btn>
      </v-row> -->

      <v-row>
        <v-col cols="1">
         <GoBack/>
        </v-col>
        <v-col class="print_button" style="padding-bottom:0" cols="8" md="8" sm="8">
          <!-- @submit="savePDF"
         v-bind:action="$PDF_URL"
          -->
          <!-- {{ pump.idid }} -->
          <form id="pdfform" v-bind:action="$PDF_URL+'?token='+token" method="POST">
            <input
              type="hidden"
              id="reportLayoutInput"
              v-model="reportLayoutInput"
              value="test"
              name="content"
            >
            <!-- <input type="hidden" v-model="reportName" value="test" name="content"> -->

            <v-btn v-if="false" @click="print" class="right" color="primary">
              <v-icon left>mdi-printer</v-icon>Print
            </v-btn>

            <v-btn v-if="pump" @click="pump.in_cart ? deleteItemFromCart(pump) : addItemToCart(pump)" class="ma-2 right"
             :color="pump.in_cart ? 'secondary' : 'primary'">
              <v-icon left v-if="!pump.in_cart">mdi-cart-plus</v-icon>
              <v-icon left v-if="pump.in_cart">mdi-cart-minus</v-icon>
              {{ pump.in_cart ? $t('cart.delete') : $t('cart.add') }}
             
            </v-btn>
            
            <v-btn v-if="pump" @click="savePDF" class="ma-2 right" color="primary">
              <v-icon left>mdi-download</v-icon>PDF
            </v-btn>
          </form>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <div class="row">
            <div class="chart" id="chartHm"></div>
            <div class="chart" id="chartEffiency"></div>
            <div class="chart" id="chartNpsh"></div>
            <div class="chart" id="chartPumpPower"></div>
            <div v-if="true" style="opacity:0" class="chart" id="chartMotorEffiency"></div>
          </div>
        </v-col>
        <v-col>
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th
                    class="text-left subtitle-1 font-weight-bold"
                    colspan="2"
                  >{{ $t('pump.pump') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ $t('pump.type') }}:</td>
                  <td>{{ pump.pump_type +" / " + pump.stage }}</td>
                </tr>
                <tr>
                  <td>{{ $t('pump.stage') }}:</td>
                  <td>{{ pump.stage }}</td>
                </tr>
                <tr>
                  <td
                    class="subtitle-1 font-weight-medium"
                    cellspan="2"
                  >{{ $t('required_duty_point') }}:</td>
                </tr>
                <tr>
                  <td>{{ $t('pump.flow') }}:</td>
                  <td>{{ flow +" "+ unit_flow_converted}}</td>
                </tr>
                <tr>
                  <td>{{ $t('pump.head') }}:</td>
                  <td>{{ head +" "+ unit_head}}</td>
                </tr>
                <tr></tr>
                <tr>
                  <td class="subtitle-1 font-weight-medium" cellspan="2">{{ $t('duty_point') }}:</td>
                </tr>
                <tr>
                  <td>{{ $t('pump.flow') }}:</td>
                  <td>{{ duttyPoint.q +" "+ unit_flow_converted}}</td>
                </tr>

                <tr>
                  <td>{{ $t('pump.head') }}:</td>
                  <td>{{ duttyPoint.hm +" "+ unit_head}}</td>
                </tr>
                <tr>
                  <td>{{ $t('pump.effiency') }}:</td>
                  <td>{{ duttyPoint.effiency +" %" }}</td>
                </tr>

                <tr>
                  <td>{{ $t('system.efficiency') }}:</td>
                  <td>{{ (duttyPoint.effiency * duttyPoint.motor_effiency/100).toFixed(2) +" %" }}</td>
                </tr>

                <tr>
                  <td>{{ $t('pump.power') }} (P2):</td>
                  <td>{{ duttyPoint.p2 }} kW</td>
                </tr>

                <tr>
                  <td>NPSHR:</td>
                  <td>{{ duttyPoint.npshr }}</td>
                </tr>

                <!-- <tr>
                  <td>Outlet Diameter:</td>
                  <td>{{ pump.outlet_diameter }}</td>
                </tr>
                -->
                <tr>
                  <td>{{ $t('pump.outside_diameter') }} (Φ R):</td>
                  <td>{{ pump.pump_diameter }} mm</td>
                </tr>

                <tr>
                  <td>{{ $t('pump.max_shaft_power') }}:</td>
                  <td>{{ pump.max_shaft_power }}</td>
                </tr>

                <tr>
                  <td>{{ $t('pump.frequency') }}:</td>
                  <td>{{ pump.frequency }} Hz</td>
                </tr>
                <!-- <tr>
                  <td>Effiency:</td>
                  <td>{{ pump.effiency }}</td>
                </tr>-->

                <!-- <tr>
                  <td>Max. Shaft Power:</td>
                  <td>{{ pump.max_shaft_power }} kW</td>
                </tr>-->

                <tr>
                  <td>{{ $t('pump.material') }}:</td>
                  <td>{{ pump.material }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>

        <!-- <p></p> -->
        <v-col>
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th
                    class="text-left subtitle-1 font-weight-bold"
                    colspan="2"
                  >{{ $t('motor.motor') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ $t('motor.type') }}:</td>
                  <td>{{ pump.motor_type }}</td>
                </tr>

                <tr>
                  <td>{{ $t('motor.power') }}:</td>
                  <td>{{ pump.motor_power }} HP</td>
                </tr>
                <tr>
                  <td>{{ $t('motor.power') }}:</td>
                  <td>{{ (pump.motor_power*0.7457).toFixed(2) }} KW</td>
                </tr>

                <tr>
                  <td>{{ $t('motor.phase') }}:</td>
                  <td>{{ pump.phase }}</td>
                </tr>

                <tr>
                  <td>{{ $t('motor.nominal_current') }}:</td>
                  <td>{{ pump.nominal_current }} A</td>
                </tr>

                <tr v-if="pump.motor_effiency">
                  <td>{{ $t('motor.nominal_efficiency') }} :</td>
                  <td>{{ pump.motor_effiency }}</td>
                </tr>

                <tr>
                  <td>{{ $t('motor.diameter') }} (Φ D):</td>
                  <td>{{ pump.motor_diameter +' mm'}}</td>
                </tr>

                <tr>
                  <td>{{ $t('motor.load_rate') }}:</td>
                  <td>{{ ((duttyPoint.p2 / (pump.motor_power*0.7457)) * 100).toFixed(2) +" %" }}</td>
                </tr>

                <!-- <tr> -->
                <!-- <td colspan="2">Voltage:</td> -->
                <!-- <td>{{ pump.voltage }} V</td> -->
                <!-- </tr> -->

                <tr>
                  <td colspan="2">
                    {{ $t('motor.voltage') }}:
                    <v-radio-group v-model="selected_voltage" row>
                      <v-radio
                        class="voltage_radio_item"
                        v-for="voltage in motor_voltages"
                        v-bind:key="voltage.value"
                        v-bind:label="voltage.text"
                        v-bind:value="voltage.value"
                      ></v-radio>
                    </v-radio-group>
                  </td>
                </tr>

                <tr v-if="duttyPoint.motor_effiency">
                  <td>Effiency:</td>
                  <td>{{ duttyPoint.motor_effiency }} %</td>
                </tr>
                <tr v-if="duttyPoint.motor_cosfi">
                  <td>Cos &phi;:</td>
                  <td>{{ (duttyPoint.motor_cosfi/100).toFixed(2) }}</td>
                </tr>

                <tr v-if="duttyPoint.selected_voltage_data.rpm">
                  <td>RPM:</td>
                  <td>{{ duttyPoint.selected_voltage_data.rpm }}</td>
                </tr>

                <tr>
                  <td>{{ $t('motor.start') }}:</td>
                  <td>{{ pump.starting }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <p></p>

          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th
                    class="text-left subtitle-1 font-weight-bold"
                    colspan="2"
                  >{{ $t('dimens_weights_lengths') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ $t('pump.outside_diameter') }} (Φ R):</td>
                  <td>{{ pump.pump_diameter }} mm</td>
                </tr>
                <tr>
                  <td>{{ $t('pump.outlet_diameter') }} (Φ E):</td>
                  <td>{{ pump.outlet_diameter }} "</td>
                </tr>

                <tr>
                  <td>{{ $t('motor.diameter') }} (Φ D):</td>
                  <td>{{ pump.motor_diameter }} mm</td>
                </tr>

                <tr>
                  <td>{{ $t('pump.length') }} (C):</td>
                  <td>{{ pump.lp }} mm</td>
                </tr>
                <tr>
                  <td>{{ $t('motor.length') }}:</td>
                  <td>{{ pump.motor_length }} mm</td>
                </tr>
                <tr>
                  <td>{{ $t('total_length') }}:</td>
                  <td>{{ ( parseFloat(pump.motor_length) + parseFloat(pump.lp)) }} mm</td>
                </tr>

                <tr>
                  <td>{{ $t('motor.protection_degree') }}:</td>
                  <td>{{ pump.degree_of_protection }}</td>
                </tr>
                <tr>
                  <td>{{ $t('motor.weight') }}:</td>
                  <td>{{ pump.motor_weight }} kg</td>
                </tr>
                <tr>
                  <td>{{ $t('pump.weight') }}:</td>
                  <td>{{ pump.pump_weight }} kg</td>
                </tr>
                <tr>
                  <td>{{ $t('total_weight') }}:</td>
                  <td>{{ parseFloat(pump.pump_weight) + parseFloat(pump.motor_weight) }} kg</td>
                </tr>

                <tr>
                  <td>{{ $t('pump.axial_load_capacity') }}:</td>
                  <td>{{ pump.axial_load_capacity }} kN</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
        <v-col v-if="false">
          <!-- <v-img width="200px" src="https://yazilimsalcozumler.com/dimensions.png"></v-img> -->
          <div class="chart" id="dimensionsImageId" style="display:none">
            <svg style="background-color:#ffffff" id="dimensionsImage" width="300" height="484"></svg>
          </div>
        </v-col>

                <v-col>
          <!-- <v-img width="200px" src="https://yazilimsalcozumler.com/dimensions.png"></v-img> -->
          <div>
            <v-img :src="dimensionsImageSrc" width="183" height="484"></v-img>
            <!-- <v-img :src="dimensionsImageSrc"  width="300" height="484"></v-img> -->
          </div>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { report, dimensionsImageBase64 } from "./report.js";
import {checkLogin, handleServerError} from "../components/utils.js";

import "./cart.js";

import GoBack from "@/components/GoBack.vue";


import * as d3 from "d3";
import { npost } from "q";
import cartMethods from './cart.js';

const pump_power_bas_son = true;
// const pump_power_bas_son = false;

// var chartOptionsForHm = {
//   height: 300,
//   width: 600
// };

var chartOptions = {
  height: 200,
  width: 640,
  gridTicksX: 10,
  gridTicksY: 10
};

var margin = { top: 30, right: 20, bottom: 20, left: 62 },
  width = chartOptions.width - margin.left - margin.right,
  height = chartOptions.height - margin.top - margin.bottom;

var svgHm, svgEffiency, svgNpsh, svgPumpPower, svgMotorEffiency;

var xScaleHm, yScaleHm;
var xScaleEffiency, yScaleEffiency;
var xScaleNpsh, yScaleNpsh;
var xScalePumpPower, yScalePumpPower;
var xScaleMotorEffiency, yScaleMotorEffiency;

function drawCircleToAnotherChart(mouseXX, pathClass, svg, xScale, yScale, r) {
  var xPos = mouseXX;

  var pathLength = d3
    .select("." + pathClass)
    .node()
    .getTotalLength();

  var x = xPos;
  var beginning = x,
    end = pathLength,
    target;
  var pos;

  if (pathLength == 0){
    labelDrawCenter("No Data Available", svg);
    return;
  };

  while (true) {
    target = Math.floor((beginning + end) / 2);
    pos = d3
      .select("." + pathClass)
      .node()
      .getPointAtLength(target);
    if ((target === end || target === beginning) && pos.x !== x) {
      break;
    }
    if (pos.x > x) end = target;
    else if (pos.x < x) beginning = target;
    else break; //position found
  }

  // console.log("x and y coordinate where vertical line intersects graph: " + [pos.x, pos.y]);
  // console.log("data where vertical line intersects graph: " + [xScale.invert(pos.x), yScaleHm.invert(pos.y)]);

  svg
    .select("circle")
    // .select(".circle"+pathClass)
    .attr("opacity", 1)
    .attr("fill", circle_color)
    .attr("cx", x)
    .attr("cy", pos.y)
    .attr("r", r);

  svg
    .selectAll(".cubuk")
    // .select(".circle"+pathClass)
    .attr("opacity", 1)
    .attr("fill", circle_color)
    .attr("cx", x)
    .attr("cy", height)
    .attr("r", r/2);

  svg
    .selectAll(".x_value")
    // .select(".circle"+pathClass)
    .attr("x", x - 29)
    .attr("y", height - 6)
    .text( xScale.invert(x).toFixed(2) );

    

  var graphY = yScale.invert(pos.y);

  svg
    .select("text")
    // .select(".clicktext"+pathClass)
    .attr("font-size", "16")
    .attr("x", x)
    .attr("y", pos.y - height - 26)
    .text(graphY.toFixed(2));

  // console.log(pathClass + ' icin noktayi buldum.: ' + graphY.toFixed(2))

  setDutyPointInfo(pathClass, graphY.toFixed(2));

  svg.select(".verticalLine").attr("transform", function() {
    return "translate(" + xPos + ",0)";
  });
}

function make_x_gridlines(x, ticks) {
  return d3.axisBottom(x).ticks(ticks);
}
function make_y_gridlines(y, ticks) {
  return d3.axisLeft(y).ticks(ticks);
}

function addGrid(svg, x, y) {
  svg
    .append("g")
    // .attr("class", "grid")
    .attr("style", 'opacity: 0.15;background-color: "#FF0000"')
    .attr("transform", "translate(0," + height + ")")
    .call(
      make_x_gridlines(x, chartOptions.gridTicksX)
        .tickSize(-height)
        .tickFormat("")
    );

  // add the Y gridlines
  svg
    .append("g")
    // .attr("class", "grid")
    .attr("style", 'opacity: 0.15;background-color: "#FF0000"')
    .call(
      make_y_gridlines(y, chartOptions.gridTicksY)
        .tickSize(-width)
        .tickFormat("")
    );
}

var hm_color = "#3972ff";
var npsh_color = "#d50000";
var pump_power_color = "#d53300";
var effiency_color = "#0039cb";
var motor_effiency_color = "#0039cb";
var circle_color = "#1b5e20";
var followMouse = true;

function drawChartHm(data) {
  console.log(data);
  var svg = d3
    .select("#chartHm")
    .append("svg")
    // .attr(
    // "viewBox",
    // `0 0 ${width + margin.left + margin.right} ${height +
    // margin.top +
    // margin.bottom}`
    // )
    .attr("width", width + margin.left + margin.right)
    .attr("height", height + margin.top + margin.bottom)
    // translate this svg element to leave some margin.
    .append("g")
    .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

  var x = d3
    .scaleLinear()
    .domain([0, Math.max.apply(null, data.xData)])
    .range([0, width]);

  var y = d3
    .scaleLinear()
    .domain([0, Math.max.apply(null, data.hm)])
    .range([height, 0]);

  xScaleHm = x;
  yScaleHm = y;

  var rect = svg
    .append("rect")
    .attr("id", "svgChartHm")
    .attr("class", "rect")
    .attr("w", "0")
    .attr("h", "0")
    .attr("width", width)
    .attr("height", height)
    .attr("fill", "#FFFFFF");

  svg
    .append("g")
    .attr("transform", "translate(0," + height + ")")
    .call(d3.axisBottom(x).ticks(chartOptions.gridTicksX));

  svg.append("g").call(d3.axisLeft(y).ticks(chartOptions.gridTicksY));

  // Add the path using this helper function
  var lineFunc = d3
    .line()
    // .curve(d3.curveLinear)
    // .curve(d3.curveMonotoneX)
    // .curve(d3.curveCatmullRom)
    .curve(d3.curveBasis)

    .x(function(d, i) {
      return x(data.xData[i]);
    })
    .y(function(d, i) {
      return y(data.hm[i]);
    });

  addGrid(svg, x, y);

  svg
    .append("path")
    .attr("class", "pathHm")
    .attr("d", lineFunc(data.xData))
    .attr("stroke", hm_color)
    .attr("fill", "none")
    .attr("stroke-width", 3);

  var verticalLine = svg
    .append("line")
    .attr("x1", 0)
    .attr("y1", 0)
    .attr("x2", 0)
    .attr("y2", height)
    .attr("stroke", "steelblue")
    .attr("class", "verticalLine");

  svg
    .append("text")
    .attr("class", "click-text")
    .attr("x", 0)
    .attr("y", 0);

  svg
    .append("circle")
    .attr("class", "circle")
    .attr("opacity", 0)
    .attr("cx", 0)
    .attr("cy", 0)
    .attr("r", 6)
    .on("click", function() {
      // var coords = d3.mouse(this);
      // var xPos = coords[0];

      // drawCircleToAnotherChart(coords[0], "pathEffiency", svgEffiency, xScaleEffiency, yScaleEffiency, 6);
      if (followMouse) followMouse = false;
      else followMouse = true;
    });

  rect
    .on("mousemove", function() {
      if (!followMouse) return;

      var coords = d3.mouse(this);
      var xPos = coords[0];

      // d3.select(".verticalLine").attr("transform", function() {
      //   return "translate(" + xPos + ",0)";
      // });

      putCircleToAllCharts(xPos);
    })
    .on("click", function() {
      if (followMouse) followMouse = false;
      else followMouse = true;
    });

  verticalLine.on("click", function() {
    // var coords = d3.mouse(this);
    // var xPos = coords[0];
    // drawCircleToAnotherChart(
    //   coords[0],
    //   "pathEffiency",
    //   svgEffiency,
    //   xScaleEffiency,
    //   yScaleEffiency,
    //   6
    // );

    followMouse = false;
  });

  // svg
  //   .selectAll("path")
  //   .on("mouseover", function() {
  //     d3.select(this).style("stroke", "orange");
  //     // .attr('stroke-width', 6)
  //   })
  //   .on("mouseout", function() {
  //     d3.select(this).style("stroke", hm_color);
  //     // .attr('stroke-width', 3)
  //     // console.log(this);
  //   })
  //   .on("click", function() {
  //     // var coords = d3.mouse(this);
  //     // console.log(coords);
  //     // drawCircle(coords[0], coords[1], 6, svg, x, y);
  //   });

  svg
    .append("circle")
    .attr("class","cubuk") 
    .attr("opacity", 1)
    .attr("fill", circle_color)
    .attr("cx", 0)
    .attr("cy", 0)
    .attr("r", 10);

  svg
    .append("text")
    .attr("class","x_value") 
    .attr("opacity", 1)
    .attr("x", 0)
    .attr("y", 0)
    .attr("font-size", "16px");


  // text label for the x axis

  labelDrawXAxis(data.h_label, svg);

  // labelDrawTopRight("XSP 12/4 60Hz     220V ", svg);

  labelDrawYAxis(data.q_label, svg);

  // labelDrawTopCenter("Q-Hm Curve", svg);
  labelDrawTopCenter(myvue.$t("chart.title.q_hm"), svg);

    labelAppendCenter(svg);

  svgHm = svg;
}

function labelDrawTopRight(text, svg) {
  svg
    .append("text")
    .attr("class", "chart_info_top_right")
    .attr("x", width)
    .attr("y", margin.top / 2)
    .style("text-anchor", "end")
    .attr("xml:space", "preserve")
    .text(text);
}

function labelDrawXAxis(text, svg) {
  svg
    .append("text")
    // .attr("class", "axis_label")
    .style("text-anchor", "middle")
    .style("font-style", "italic")
    .style("font-weight", 400)
    .style("font-size", "16px")
    .text(text)
    .attr("x", -height / 2)
    .attr("y", -40)
    .attr("transform", "rotate(-90)");
}

function labelDrawYAxis(text, svg) {
  return;
  // if (svg != svgPumpPower)
  // return;
  svg
    .append("text")
    .style("text-anchor", "middle")
    .style("font-style", "italic")
    .style("font-weight", 400)
    .style("font-size", "16px")
    // .style("font-style","italic")
    // .attr("class", "axis_label")
    .attr("x", width / 2)
    .attr("y", height + 24)
    // .style("text-anchor", "middle")
    .text(text);
  // .attr("transform","rotate(-90)")
  //  .attr("transform","rotate(-90)")
}

function updateChartLabelsForLocale() {
  d3.select(".chart_title").text("TEST");
}

function labelDrawTopCenter(text, svg) {
  svg
    .append("text")
    .attr("class", "chart_title")
    .attr("x", width / 2)
    .attr("y", -17)
    .style("text-anchor", "middle")
    .style("font-weight", 400)
    .style("font-style", "italic")
    .text(text);
  // .attr("transform","rotate(-90)")
  //  .attr("transform","rotate(-90)")
}

function labelDrawCenter(text, svg) {
  console.log("drawCenter called!!!")

  svg
    .select(".chart_no_data")
    .attr("x", width / 2)
    .attr("y", height / 2)
    .style("text-anchor", "middle")
    .style("font-weight", 400)
    .style("font-style", "italic")
    .text(text);
  // .attr("transform","rotate(-90)")
  //  .attr("transform","rotate(-90)")
}


function labelAppendCenter(svg) {
svg
    .append("text")
    .attr("class", "chart_no_data")
    .attr("x", width / 2)
    .attr("y", height / 2)
    .style("text-anchor", "middle")
    .style("font-weight", 400)
    .style("font-style", "italic")
    .text("");
}

function putCircleToAllCharts(xPos) {
  setDutyPointInfo("q", xScaleHm.invert(xPos).toFixed(2));

  drawCircleToAnotherChart(xPos, "pathHm", svgHm, xScaleHm, yScaleHm, 6);

  drawCircleToAnotherChart(
    xPos,
    "pathEffiency",
    svgEffiency,
    xScaleEffiency,
    yScaleEffiency,
    6
  );
  

  drawCircleToAnotherChart(
    xPos,
    "pathPumpPower",
    svgPumpPower,
    xScalePumpPower,
    yScalePumpPower,
    6
  );

    drawCircleToAnotherChart(
      xPos,
      "pathNpsh",
      svgNpsh,
      xScaleNpsh,
      yScaleNpsh,
      6
    );
  


  if (svgMotorEffiency != null) {
    drawCircleToAnotherChart(
      xPos,
      "pathMotorCosfi",
      svgMotorEffiency,
      xScaleMotorEffiency,
      yScaleMotorEffiency,
      6
    );

    drawCircleToAnotherChart(
      xPos,
      "pathMotorEffiency",
      svgMotorEffiency,
      xScaleMotorEffiency,
      yScaleMotorEffiency,
      6
    );
  }
}

window.setDutyPointInfo = {};
window.t = {};

function drawChartEffiency(data) {
  var svg = d3
    .select("#chartEffiency")
    .append("svg")
    // .attr(
    // "viewBox",
    // `0 0 ${width + margin.left + margin.right} ${height +
    // margin.top +
    // margin.bottom}`
    // )
    .attr("width", width + margin.left + margin.right)
    .attr("height", height + margin.top + margin.bottom)
    // translate this svg element to leave some margin.
    .append("g")
    .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

  var rect = svg
    .append("rect")
    .attr("w", "0")
    .attr("h", "0")
    .attr("width", width)
    .attr("height", height)
    .attr("fill", "#FFFFFF");

  var x = d3
    .scaleLinear()
    .domain([0, Math.max.apply(null, data.xData)])
    .range([0, width]);

  var y = d3
    .scaleLinear()
    .domain([0, 100])
    // .domain([0, Math.max.apply(null, data.effiency)])
    .range([height, 0]);

  xScaleEffiency = x;
  yScaleEffiency = y;

  var lineFunc = d3
    .line()
    // .curve(d3.curveMonotoneX)
    .curve(d3.curveBasis)
    // .curve(d3.curveCatmullRom)
    .x(function(d, i) {
      return x(data.xData[i]);
    })
    .y(function(d, i) {
      return y(data.effiency[i]);
    });

  svg
    .append("g")
    .attr("transform", "translate(0," + height + ")")
    .call(d3.axisBottom(x));

  svg.append("g").call(d3.axisLeft(y));

  // svg.call(d3.axisLeft(y))

  addGrid(svg, x, y);

  // Add the path using this helper function
  svg
    .append("path")
    .attr("class", "pathEffiency")
    .attr("d", lineFunc(data.xData))
    .attr("stroke", effiency_color)
    .attr("fill", "none")
    .attr("stroke-width", 3);

  var verticalLine = svg
    .append("line")
    .attr("x1", 0)
    .attr("y1", 0)
    .attr("x2", 0)
    .attr("y2", height)
    .attr("stroke", "steelblue")
    .attr("class", "verticalLine");

  svg
    .append("circle")
    .attr("class", "circle")
    .attr("opacity", 0)
    .attr("cx", 0)
    .attr("cy", 0)
    .attr("r", 6);

  svg
    .append("text")
    .attr("class", "click-text")
    .attr("x", 0)
    .attr("y", 0);

  // svg
  //   .selectAll("path")
  //   .on("mouseover", function() {
  //     d3.select(this).style("stroke", "orange");
  //     // .attr('stroke-width', 6)
  //   })
  //   .on("mouseout", function() {
  //     d3.select(this).style("stroke", effiency_color);
  //     // .attr('stroke-width', 3)
  //     // console.log(this);
  //   })
  //   .on("click", function() {
  //     var coords = d3.mouse(this);
  //     console.log(coords);
  //     drawCircle(coords[0], coords[1], 6, svg, x, y);
  //   });

  labelDrawXAxis(data.effiency_label + " (%)", svg);

  // labelDrawTopRight("XSP 12/4 60Hz     220V ", svg);

  labelDrawYAxis(data.q_label, svg);

  // labelDrawTopCenter("Q-Efficiency Curve", svg);
  labelDrawTopCenter(myvue.$t("chart.title.q_efficiency"), svg);

    labelAppendCenter(svg);


  svgEffiency = svg;
}

function drawChartNpsh(data) { 

  var svg = d3
    .select("#chartNpsh")
    .append("svg")
    // .attr(
    // "viewBox",
    // `0 0 ${width + margin.left + margin.right} ${height +
    // margin.top +
    // margin.bottom}`
    // )
    .attr("width", width + margin.left + margin.right)
    .attr("height", height + margin.top + margin.bottom)
    // translate this svg element to leave some margin.
    .append("g")
    .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

  var rect = svg
    .append("rect")
    .attr("w", "0")
    .attr("h", "0")
    .attr("width", width)
    .attr("height", height)
    .attr("fill", "#FFFFFF");

  var x = d3
    .scaleLinear()
    .domain([0, Math.max.apply(null, data.xData)])
    .range([0, width]);

  var y = d3
    .scaleLinear()
    .domain([0, 100])
    // .domain([0, Math.max.apply(null, data.npshr)])
    .range([height, 0]);

  xScaleNpsh = x;
  yScaleNpsh = y;

  var lineFunc = d3
    .line()
    // .curve(d3.curveMonotoneX)
    // .curve(d3.curveCatmullRom)
    .curve(d3.curveBasis)
    .x(function(d, i) {
      return x(data.xData[i]);
    })
    .y(function(d, i) {
      return y(data.npshr[i]);
    });

  svg
    .append("g")
    .attr("transform", "translate(0," + height + ")")
    .call(d3.axisBottom(x));

  svg.append("g").call(d3.axisLeft(y));

  // svg.call(d3.axisLeft(y))
  addGrid(svg, x, y);

  // Add the path using this helper function
  svg
    .append("path")
    .attr("class", "pathNpsh")
    .attr("d", lineFunc(data.xData))
    .attr("stroke", npsh_color)
    .attr("fill", "none")
    .attr("stroke-width", 3);

  var verticalLine = svg
    .append("line")
    .attr("x1", 0)
    .attr("y1", 0)
    .attr("x2", 0)
    .attr("y2", height)
    .attr("stroke", "steelblue")
    .attr("class", "verticalLine");

  svg
    .append("circle")
    .attr("class", "circle-path")
    .attr("opacity", 0)
    .attr("cx", 0)
    .attr("cy", 0)
    .attr("r", 6);

  svg
    .append("text")
    .attr("class", "click-text")
    .attr("x", 0)
    .attr("y", 0);

  // svg
  //   .selectAll("path")
  //   .on("mouseover", function() {
  //     d3.select(this).style("stroke", "orange");
  //     // .attr('stroke-width', 6)
  //   })
  //   .on("mouseout", function() {
  //     d3.select(this).style("stroke", npsh_color);
  //     // .attr('stroke-width', 3)
  //     // console.log(this);
  //   })
  //   .on("click", function() {
  //     var coords = d3.mouse(this);
  //     console.log(coords);
  //     drawCircle(coords[0], coords[1], 6, svg, x, y);
  //   });

  labelDrawXAxis(data.npshr_label + " (m)", svg);

  labelDrawYAxis(data.q_label, svg);

  // labelDrawTopCenter("Q-NPSHR Curve", svg);
  labelDrawTopCenter(myvue.$t("chart.title.q_npshr"), svg);

    labelAppendCenter(svg);

  svgNpsh = svg;
}

function drawChartPumpPower(data) {
  var svg = d3
    .select("#chartPumpPower")
    .append("svg")
    .attr("width", width + margin.left + margin.right)
    .attr("height", height + margin.top + margin.bottom)
    // translate this svg element to leave some margin.
    .append("g")
    .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

  var rect = svg
    .append("rect")
    .attr("w", "0")
    .attr("h", "0")
    .attr("width", width)
    .attr("height", height)
    .attr("fill", "#FFFFFF");

  var x = d3
    .scaleLinear()
    .domain([0, Math.max.apply(null, data.xData)])
    .range([0, width]);

  var y = d3
    .scaleLinear()
    // .domain([0, 100])
    .domain([0, 1.2 * Math.max.apply(null, data.power)])
    .range([height, 0]);

  xScalePumpPower = x;
  yScalePumpPower = y;

  var lineFunc = d3
    .line()
    // .curve(d3.curveMonotoneX)
    // .curve(d3.curveCatmullRom)
    .curve(d3.curveBasis)
    .x(function(d, i) {
      return x(data.xData[i]);
    })
    .y(function(d, i) {
      return y(data.power[i]);
    });

  svg
    .append("g")
    .attr("transform", "translate(0," + height + ")")
    .call(d3.axisBottom(x));

  svg.append("g").call(d3.axisLeft(y));

  // svg.call(d3.axisLeft(y))
  addGrid(svg, x, y);

  // Add the path using this helper function
  svg
    .append("path")
    .attr("class", "pathPumpPower")
    .attr("d", lineFunc(data.xData))
    .attr("stroke", pump_power_color)
    .attr("fill", "none")
    .attr("stroke-width", 3);

  var verticalLine = svg
    .append("line")
    .attr("x1", 0)
    .attr("y1", 0)
    .attr("x2", 0)
    .attr("y2", height)
    .attr("stroke", "steelblue")
    .attr("class", "verticalLine");

  svg
    .append("circle")
    .attr("class", "circle")
    .attr("opacity", 0)
    .attr("cx", 0)
    .attr("cy", 0)
    .attr("r", 6);

  svg
    .append("text")
    .attr("class", "click-text")
    .attr("x", 0)
    .attr("y", 0);

  // svg
  //   .selectAll("path")
  //   .on("mouseover", function() {
  //     d3.select(this).style("stroke", "orange");
  //     // .attr('stroke-width', 6)
  //   })
  //   .on("mouseout", function() {
  //     d3.select(this).style("stroke", npsh_color);
  //     // .attr('stroke-width', 3)
  //     // console.log(this);
  //   })
  //   .on("click", function() {
  //     var coords = d3.mouse(this);
  //     console.log(coords);
  //     drawCircle(coords[0], coords[1], 6, svg, x, y);
  //   });

  labelDrawXAxis(data.power_label + " (kW)", svg);


  labelDrawYAxis(data.q_label, svg);
  // labelDrawTopCenter("Q-Ne Curve", svg);
  labelDrawTopCenter(myvue.$t("chart.title.q_ne"), svg);

  labelAppendCenter(svg);

  svgPumpPower = svg;
}

function drawChartMotorEffiency(data) {
  d3.select("#chartMotorEffiency svg").remove();

  var svg = d3
    .select("#chartMotorEffiency")
    .append("svg")
    .attr("width", width + margin.left + margin.right)
    .attr("height", height + margin.top + margin.bottom)
    .append("g")
    .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

  var rect = svg
    .append("rect")
    .attr("w", "0")
    .attr("h", "0")
    .attr("width", width)
    .attr("height", height)
    .attr("fill", "#FFFFFF");

  var x = d3
    .scaleLinear()
    .domain([45, Math.max.apply(null, data.xData)])
    .range([0, width]);

  var y = d3
    .scaleLinear()
    .domain([0, 100])
    // .domain([0, Math.max.apply(null, data.effiency)])
    .range([height, 0]);

  xScaleMotorEffiency = x;
  yScaleMotorEffiency = y;

  var lineFunc = d3
    .line()
    // .curve(d3.curveMonotoneX)
    .curve(d3.curveBasis)
    // .curve(d3.curveCatmullRom)
    .x(function(d, i) {
      return x(data.xData[i]);
    })
    .y(function(d, i) {
      return y(data.effiency[i]);
    });

  var lineFuncCosfi = d3
    .line()
    // .curve(d3.curveMonotoneX)
    .curve(d3.curveBasis)
    // .curve(d3.curveCatmullRom)
    .x(function(d, i) {
      return x(data.xData[i]);
    })
    .y(function(d, i) {
      return y(data.cosfi[i] * 100);
    });

  svg
    .append("g")
    .attr("transform", "translate(0," + height + ")")
    .call(d3.axisBottom(x));

  svg.append("g").call(d3.axisLeft(y));

  // svg.call(d3.axisLeft(y))

  addGrid(svg, x, y);

  // Add the path using this helper function
  svg
    .append("path")
    .attr("class", "pathMotorEffiency")
    .attr("d", lineFunc(data.xData))
    .attr("stroke", motor_effiency_color)
    .attr("fill", "none")
    .attr("stroke-width", 3);

  svg
    .append("path")
    .attr("class", "pathMotorCosfi")
    .attr("d", lineFuncCosfi(data.xData))
    .attr("stroke", "#FF0000")
    .attr("fill", "none")
    .attr("stroke-width", 3);

  var verticalLine = svg
    .append("line")
    .attr("x1", 0)
    .attr("y1", 0)
    .attr("x2", 0)
    .attr("y2", height)
    .attr("stroke", "steelblue")
    .attr("class", "verticalLine");

  svg
    .append("circle")
    .attr("class", "circle")
    .attr("opacity", 0)
    .attr("cx", 0)
    .attr("cy", 0)
    .attr("r", 6);

  svg
    .append("circle")
    .attr("class", "circle")
    .attr("opacity", 0)
    .attr("cx", 0)
    .attr("cy", 0)
    .attr("r", 6);

  svg
    .append("text")
    .attr("class", "click-text")
    .attr("x", 0)
    .attr("y", 0);

  svg
    .append("text")
    .attr("class", "click-text")
    .attr("x", 0)
    .attr("y", 0);

  labelDrawXAxis(data.effiency_label + " (%)", svg);

  labelDrawYAxis(data.q_label, svg);

  labelDrawTopCenter("Motor Load-Efficiency Curve", svg);
  // labelDrawTopCenter(myvue.$t('chart.title.q_ne'), svg);

    labelAppendCenter(svg);


  svgMotorEffiency = svg;
}

var unit_flow = "";

export default {
  name: "PumpReport",
  data: () => ({
    cart: [],
    dimensionsImageSrc: "",
    selected_voltage: "",
    motor_voltages: [],
    // reportName: "",
    reportLayoutInput: "",
    unit_flow_converted: "",
    token: "",
    motor: [],
    flow_carpan: 1.0,
    head_carpan: 1.0,
    unit_flow_html: "",
    unit_head_html: "",
    duttyPoint: {
      q: "",
      hm: "",
      effiency: "",
      npshr: "",
      p2: "",
      selected_voltage_data: ""
    },
    pump: ""

    // chartMotorEfficiency: {
    //   xData: [],
    //   cosfi: [],
    //   effiency: [],
    //   effiency_label: "Effiency",
    //   q_label: "Load Rate"
    // },
  }),
  props: {
    idmotor: {
      type: String,
      default: ""
    },
    idpump_perf: {
      type: String,
      default: ""
    },
    unit_flow: {
      type: String,
      default: ""
    },
    unit_head: {
      type: String,
      default: ""
    },
    pumpid: {
      type: String,
      default: ""
    },
    stage: {
      type: String,
      default: ""
    },
    flow: {
      type: String,
      default: ""
    },
    head: {
      type: String,
      default: ""
    },
    frequency: {
      type: String,
      default: ""
    },
    // head_carpan: {
    //   type: Float,
    //   default: 1.0
    // },
    // flow_carpan: {
    //   type: Float,
    //   default: 1.0
    // },
  },
  watch: {
    selected_voltage: function(newIndex, oldIndex) {
      var motorGraph = this.motor[newIndex];
      this.duttyPoint.selected_voltage_data = motorGraph;

      this.fillChartMotor(motorGraph);

      drawChartMotorEffiency(this.chartMotorEfficiency);

      var xPos = xScaleHm(this.duttyPoint.q);

      if (svgMotorEffiency != null) {
        drawCircleToAnotherChart(
          xPos,
          "pathMotorCosfi",
          svgMotorEffiency,
          xScaleMotorEffiency,
          yScaleMotorEffiency,
          6
        );

        drawCircleToAnotherChart(
          xPos,
          "pathMotorEffiency",
          svgMotorEffiency,
          xScaleMotorEffiency,
          yScaleMotorEffiency,
          6
        );
      }
    }
    // unit_flow: function(newVal, oldVal){
    //   if (newVal == "m3_h"){
    //     unit_flow_html = "m3_h_html"
    //   }else{
    //     unit_flow_html = newVal
    //   }
    // }
  },
  computed: {
    chartPumpPower() {
      return {
        xData: [],
        power: [],
        q_label: "Q",
        power_label: this.$t("pump.power")
      };
    },

    chart2() {
      return {
        xData: [],
        hm: [],
        q_label: "Q",
        h_label: "H"
      };
    },
    chart1() {
      return {
        xData: [],
        effiency: [],
        npshr: [],
        effiency_label: this.$t("pump.effiency"),
        npshr_label: "NPSHR",
        q_label: "Q"
      };
    },
    chartMotorEfficiency() {
      return {
        xData: [],
        cosfi: [],
        effiency: [],
        effiency_label: "Effiency",
        q_label: "Load Rate"
      };
    }
  },
  mounted: function() {
    // this.initLocalStorageCart();

    if (localStorage.token) {
      this.token = localStorage.token;
      this.$http.defaults.headers.common["Authorization"] = `Bearer ${
        this.token
      }`;
    } else {
      this.$router.push('/')
    }

    if (this.idpump_perf != "" && this.pumpid != "") {
      this.carpanlariBelirle();

      setDutyPointInfo = this.setDutyPointInfo;
      this.fetchPumpPerfData();
    }

    if (this.unit_flow == "m3_h") this.unit_flow_converted = "m\u00B3/h";
    if (this.unit_flow == "gpm") this.unit_flow_converted = "GPM";
    else if (this.unit_flow == "l_sec") this.unit_flow_converted = "l/sec";
    else if (this.unit_flow == "l_min") this.unit_flow_converted = "l/min";

    t = this.$t;

    // this.$ls.on("cart", this.cartChanged);
  },

  // TODO: en basta pump-perf bitmeli.
components: {
GoBack
},
  methods: {

    
    initLocalStorageCart: function() {
      try {
        this.cart = JSON.parse(this.$ls.get("cart", []));
        this.$ls.on("cart", this.cartChanged);
      } catch (e) {
        // alert(e)
        this.cart = [];
        this.$ls.on("cart", this.cartChanged);
      }
    },
    cartChanged: function(val, oldVal, uri) {
      console.log("cart changed -- pumpreport.vue");
      try {
        this.cart = JSON.parse(val);
      } catch (e) {
        this.cart = [];
      }
    },
     deleteItemFromCart: function(item) {
      this.$http({
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        url: this.$API_URL + "delete_cart_item",
        data: item
      })
        .then(response => {
          // checkLogin(response, this.token)
          console.log(response.data);
          if (response.data == "1") this.pump.in_cart = 0;
          
        })
        .catch(function(error) {
          alert(error);
          // handleServerError(error);
          console.log(error);
        });
    },
    addItemToCart: function(item) { 
      this.$http({
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        url: this.$API_URL + "save_cart_item",
        data: item
      })
        .then( response => {
          // checkLogin(response, this.token)
          if (response.data == "1") this.pump.in_cart = 1;
          console.log(response.data)
          // this.getCart()
        })
        .catch(function(error) {
          // alert(error)
          handleServerError(error)
          console.log(error);
        });
    
    },
    
    preSVG: function(chart) {
      chart = chart.replace(/currentColor/g, "#000000");
      // chart = chart.replace("<svg width=\"600\" height=\"300\"","<svg viewBox=\"0 0 300 300\"")
      chart = chart.replace(
        '<svg width="' +
          chartOptions.width +
          '" height="' +
          chartOptions.height +
          '"',
        '<svg viewBox="0 0 ' +
          chartOptions.width +
          " " +
          chartOptions.height +
          '"'
      );

      return chart;
    },
    savePDF: function(event) {
       
      const currentLang = this.$i18n.locale;

      if ( currentLang == 'ar'){
        this.$i18n.locale = 'en'
        setTimeout(() => {  
        // console.log('locale')
        // console.log(this.$i18n.locale)
        this._savePDF()
        this.$i18n.locale = currentLang
       }, 1000);
       return
      } 

      this._savePDF()
      

    },
    _savePDF: function(){
var chartHm = document.getElementById("chartHm").innerHTML;
      var chartEffiency = document.getElementById("chartEffiency").innerHTML;
      var chartNpshr = document.getElementById("chartNpsh").innerHTML;
      var chartPumpPower = document.getElementById("chartPumpPower").innerHTML;

      var dimensionsImage;
      //  = document.getElementById("dimensionsImageId")
      //   .innerHTML;

      chartHm = this.preSVG(chartHm);
      chartEffiency = this.preSVG(chartEffiency);
      chartNpshr = this.preSVG(chartNpshr);
      chartPumpPower = this.preSVG(chartPumpPower);

      // chartHm = chartHm.replace(/currentColor/g, "#000000");
      // chartEffiency = chartEffiency.replace(/currentColor/g, "#000000");

      // chartHm = chartHm.replace("<svg width=\"600\" height=\"300\"","<svg viewBox=\"0 0 600 300\"")
      // chartEffiency = chartEffiency.replace("<svg width=\"600\" height=\"300\"","<svg viewBox=\"0 0 600 300\"")
      // chartHm = chartHm.replace("<svg width=\"600\" height=\"300\"","<svg ")
      // console.log(svgg)

      // downloading from server.

      var reportLayout = report(
        chartHm,
        chartEffiency,
        chartNpshr,
        chartPumpPower,
        this.duttyPoint,
        this.unit_flow,
        this.unit_head,
        this.pump,
        this.motor,
        dimensionsImage
      );

      // alert(reportLayout)

      this.createPDFFromServer(reportLayout);

      // this.createPDFInBrowser(reportLayout);

      // .download(this.pump.pump_type +"/"+ this.pump.stage +"-"+ this.pump.motor_type +"_"+ this.pump.motor_power+" HP.pdf" );
    },
    createPDFInBrowser: function(reportLayout) {
      pdfMake.createPdf(reportLayout).open();
    },
    createPDFFromServer: function(reportLayout) {
      reportLayout.filename =
        this.pump.pump_type +
        "/" +
        this.pump.stage +
        "-" +
        this.pump.motor_type +
        "_" +
        this.pump.motor_power +
        " HP.pdf";

      this.reportLayoutInput = "dd = " + JSON.stringify(reportLayout);

      document.getElementById("reportLayoutInput").value =
        "dd = " + JSON.stringify(reportLayout);

      document.getElementById("pdfform").submit();

      // var fileName = this.pump.pump_type +"/"+ this.pump.stage +"-"+ this.pump.motor_type +"_"+ this.pump.motor_power+" HP.pdf";
      // this.reportName = "filename = "+ JSON.stringify(fileName);
    },
    print: function() {
      window.print();
    },
    carpanlariBelirle: function() {
      if (this.unit_flow == "gpm") this.flow_carpan = 0.2271;
      else if (this.unit_flow == "l_sec") this.flow_carpan = 3.6;
      else if (this.unit_flow == "l_min") this.flow_carpan = 0.06;
      else this.flow_carpan = 1.0;

      if (this.unit_head == "ft") this.head_carpan = 0.3048;
      else this.head_carpan = 1.0;
    },

    setDutyPointInfo: function(pathClass, value) {
      if (pathClass == "pathHm") this.duttyPoint.hm = value;
      else if (pathClass == "pathEffiency") this.duttyPoint.effiency = value;
      else if (pathClass == "pathNpsh") this.duttyPoint.npshr = value;
      else if (pathClass == "pathPumpPower") this.duttyPoint.p2 = value;
      else if (pathClass == "q") this.duttyPoint.q = value;
      else if (pathClass == "pathMotorEffiency")
        this.duttyPoint.motor_effiency = value;
      else if (pathClass == "pathMotorCosfi")
        this.duttyPoint.motor_cosfi = value;
    },
    fetchMotorPerfData: function() {
      this.$http
        .get(
          this.$API_URL +
            "motor-perfs?motorid=" +
            this.idmotor +
            "&frequency=" +
            this.frequency
        )
        .then(result => {

          // checkLogin(result, this.token)

          console.log(result.data);

          this.motor = result.data;
          if (this.motor.length == 0) return;

          // this.chartMotorEfficiency.xData.push(25);
          // this.chartMotorEfficiency.effiency.push(parseFloat(motorGraph.eff25));

          this.motor_voltages = [];
          var index = 0;
          this.motor.forEach(motorPerf => {
            this.motor_voltages.push({
              text: motorPerf.voltage + " V",
              value: index
            });
            index++;
          });

          this.selected_voltage = this.motor_voltages[0].value;

          console.log(this.motor_voltages);
        });
    },

    fillChartMotor: function(motorGraph) {
      this.chartMotorEfficiency.effiency = [];
      this.chartMotorEfficiency.cosfi = [];
      this.chartMotorEfficiency.xData = [];

      this.chartMotorEfficiency.xData.push(50);
      this.chartMotorEfficiency.effiency.push(parseFloat(motorGraph.eff50));
      this.chartMotorEfficiency.cosfi.push(parseFloat(motorGraph.cosfi50));

      this.chartMotorEfficiency.xData.push(75);
      this.chartMotorEfficiency.effiency.push(parseFloat(motorGraph.eff75));
      this.chartMotorEfficiency.cosfi.push(parseFloat(motorGraph.cosfi75));

      this.chartMotorEfficiency.xData.push(100);
      this.chartMotorEfficiency.effiency.push(parseFloat(motorGraph.eff100));
      this.chartMotorEfficiency.cosfi.push(parseFloat(motorGraph.cosfi100));
    },

    fetchPump: function(pumpId, idpump_perf, idmotor) {

      this.$http
        .get(
          this.$API_URL +
            "pump_for_report?idpump=" +
            pumpId +
            "&idpump_perf=" +
            idpump_perf +
            "&idmotor=" +
            idmotor +
            "&frequency=" +
            this.frequency +
            "&dutypoint_q=" +
            (this.flow * this.flow_carpan).toFixed(2) +
            "&dutypoint_h=" +
            (this.head * this.head_carpan).toFixed(2)
        )
        .then(result => {
          // checkLogin(result, this.token)

          result.data.hm /= this.head_carpan;
          result.data.q /= this.flow_carpan;

          result.data.hm = result.data.hm.toFixed(2);
          result.data.q = result.data.q.toFixed(2);

          this.pump = result.data;

          putCircleToAllCharts(xScaleHm(this.pump.q));

          // this.drawDimensionsToImage();
          this.getDimensionsImage();


        });
    },

    drawDimensionsToImage: function() {
      // "https://yazilimsalcozumler.com/dimensions.png
      var svg = d3.select("#dimensionsImage");
      var myimage = svg
        .append("image")
        .attr("xlink:href", dimensionsImageBase64())
        // .attr('xlink:href', 'https://yazilimsalcozumler.com/dimensions2.png')
        .attr("width", 183)
        .attr("height", 484)
        .attr("x", 300 / 2 - 183 / 2);

      var dimensionLabelFontSize = "14";

      svg
        .append("text")
        .attr("font-size", dimensionLabelFontSize)
        .attr("x", 90)
        .attr("y", 164)
        .style("text-anchor", "end")
        .attr("xml:space", "preserve")
        .text(this.pump.lp + " mm");

      svg
        .append("text")
        .attr("font-size", dimensionLabelFontSize)
        .attr("x", 90)
        .attr("y", 373)
        .style("text-anchor", "end")
        .attr("xml:space", "preserve")
        .text(this.pump.motor_length + " mm");

      svg
        .append("text")
        .attr("font-size", dimensionLabelFontSize)
        .attr("x", 210)
        .attr("y", 270)
        .style("text-anchor", "start")
        .attr("xml:space", "preserve")
        .text(
          parseFloat(this.pump.motor_length) + parseFloat(this.pump.lp) + " mm"
        );

      svg
        .append("text")
        .attr("font-size", dimensionLabelFontSize)
        .attr("x", 150)
        .attr("y", 350)
        .style("text-anchor", "middle")
        .attr("xml:space", "preserve")
        .text(this.pump.motor_diameter + " mm");

      svg
        .append("text")
        .attr("font-size", dimensionLabelFontSize)
        .attr("x", 150)
        .attr("y", 17)
        .style("text-anchor", "middle")
        .attr("xml:space", "preserve")
        .text(this.pump.fi_e + '"');

      // myimage.attr('x', 50)
      // myimage.attr('transform', 'rotate(90)')
    },

    getDimensionsImage: function() {
      // "https://yazilimsalcozumler.com/dimensions.png

      this.dimensionsImageSrc = this.$API_URL+'get-dimensions-image?lp=' +
            this.pump.lp + 
            "&motor_length=" +
            this.pump.motor_length + 
            "&total_length=" +
            (parseFloat(this.pump.motor_length) + parseFloat(this.pump.lp)) +
            "&motor_diameter=" +
            this.pump.motor_diameter +
            "&fi_e=" +
            this.pump.fi_e;

      

      // myimage.attr('x', 50)
      // myimage.attr('transform', 'rotate(90)')
    },

    



    fetchPumpPerfData: function() {
      this.$http
        .get(
          this.$API_URL +
            "pumps-perfs?pumpid=" +
            this.pumpid +
            "&stage=" +
            this.stage +
            "&idpump_perf=" +
            this.idpump_perf +
            "&frequency=" +
            this.frequency
        )
        .then(result => {
          // checkLogin(result, this.token)

          // this.pumps = result.data;
          console.log(result.data);
          this.chart1.xData = [];
          this.chart1.effiency = [];
          this.chart1.npshr = [];
          result.data.forEach(perfPoint => {
            this.chart1.xData.push(parseFloat(perfPoint.q) / this.flow_carpan);
            this.chart1.effiency.push(parseFloat(perfPoint.effiency));
            this.chart1.npshr.push(parseFloat(perfPoint.npshr));

            this.chart2.xData.push(parseFloat(perfPoint.q) / this.flow_carpan);
            this.chart2.hm.push(parseFloat(perfPoint.hm) / this.head_carpan);

            this.chartPumpPower.xData.push(
              parseFloat(perfPoint.q) / this.flow_carpan
            );
            // pumpPower KW
            var pumpPower = (
              (perfPoint.hm * perfPoint.q * 0.2718755555555556) /
              perfPoint.effiency
            ).toFixed(2);

            // console.log('calculated power: '+pumpPower+' kW\n Head: ' + perfPoint.hm
            // + ' Q: ' + perfPoint.q + ' Effiency: ' + perfPoint.effiency +'\n\n' )

            this.chartPumpPower.power.push(isNaN(pumpPower) ? 0 : pumpPower);
          });

          if (pump_power_bas_son) {
            if (this.chartPumpPower.power[0] == 0)
              this.chartPumpPower.power[0] = this.chartPumpPower.power[1];

            this.chartPumpPower.power[
              this.chartPumpPower.power.length - 1
            ] = this.chartPumpPower.power[this.chartPumpPower.power.length - 2];
          }

          console.log(this.chart2.xData);
          console.log(this.chart2.hm);

          if (this.unit_flow == "gpm") this.chart1.q_label = "Q (GPM)";
          else if (this.unit_flow == "l_sec") this.chart1.q_label = "Q (l/sec)";
          else if (this.unit_flow == "l_min") this.chart1.q_label = "Q (l/min)";
          else this.chart1.q_label = "Q (m3/h)";

          this.chart2.q_label = this.chart1.q_label;
          this.chartPumpPower.q_label = this.chart1.q_label;

          if (this.unit_head == "ft") this.chart2.h_label = "H (ft)";
          else this.chart2.h_label = "H (m)";

          // test amacli veri.
          // this.chart1.xData = []
          // this.chart1.effiency = []
          // this.chart1.npshr = []

          // this.chart2.xData = []
          // this.chart2.xData = []

          // this.chartPumpPower.xData = []
          // this.chartPumpPower.power = []

          // var floww = [0,6,8,10,12,14,16,18, 20];
          // var hmm = [ 56.13, 56.21, 54.83, 52.76, 49.98, 46.50, 42.32, 37.44, 31.86]
          // var powerr = [1.74, 1.86, 1.98, 2.09, 2.20, 2.31, 2.40, 2.48, 2.53]
          // var npshh = [ 1.20,  1.24, 1.25, 1.34, 1.56, 1.98, 2.64, 3.59, 4.90]
          // var efff = [  0.00 ,49.44 ,60.41 ,68.64 ,74.11 ,76.85 ,76.83 ,74.07 ,68.57 ]

          // this.chart1.xData = floww
          // this.chart1.effiency = efff
          // this.chart1.npshr = npshh
          // this.chart2.xData = floww
          // this.chart2.hm = hmm
          // this.chartPumpPower.xData = floww
          // this.chartPumpPower.power = powerr
          // test amacli veri sonu

          //

          var chartHmRightLabel = drawChartHm(this.chart2);
          drawChartEffiency(this.chart1);
          drawChartNpsh(this.chart1);

          drawChartPumpPower(this.chartPumpPower);

          followMouse = false;

          this.fetchMotorPerfData();
          this.fetchPump(this.pumpid, this.idpump_perf, this.idmotor);
          // draw1(this.chart1);
          // draw2(this.chart2);
          // drawGoogleChart();
        });
    }
  }
};

// https://jsfiddle.net/g0zh8k26/1/
</script>
 

 <style src="./style.css"></style>
